const ANNOUNCEMENT_MILESTONES_UNDER_ONE_MINUTE = new Set([60, 30, 10]);

export const shouldAnnounceResendCountdown = (remainingTime: number) => {
  if (remainingTime <= 0) {
    return false;
  }

  if (remainingTime > 60) {
    return remainingTime % 30 === 0;
  }

  return ANNOUNCEMENT_MILESTONES_UNDER_ONE_MINUTE.has(remainingTime) || remainingTime <= 5;
};
